(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collections-banner-reverse"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.cbr-carousel-wrap').forEach(function (wrap) {
    var carousel = wrap.querySelector('[data-cbr-carousel]');
    var prevBtn = wrap.querySelector('[data-cbr-prev]');
    var nextBtn = wrap.querySelector('[data-cbr-next]');
    if (!carousel || !prevBtn || !nextBtn) return;

    function getScrollAmount() {
      var card = carousel.querySelector('.cbr-product-card');
      if (!card) return 300;
      var style = window.getComputedStyle(carousel);
      var gap = parseInt(style.columnGap || style.gap || 16, 10);
      return card.getBoundingClientRect().width + gap;
    }

    function updateArrows() {
      var maxScroll = carousel.scrollWidth - carousel.clientWidth - 2;
      prevBtn.disabled = carousel.scrollLeft <= 0;
      nextBtn.disabled = carousel.scrollLeft >= maxScroll;
    }

    prevBtn.addEventListener('click', function () {
      carousel.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
      carousel.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
    });

    carousel.addEventListener('scroll', updateArrows);
    window.addEventListener('resize', updateArrows);
    updateArrows();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collections-banner"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.cb-carousel-wrap').forEach(function (wrap) {
    var carousel = wrap.querySelector('[data-cb-carousel]');
    var prevBtn = wrap.querySelector('[data-cb-prev]');
    var nextBtn = wrap.querySelector('[data-cb-next]');
    if (!carousel || !prevBtn || !nextBtn) return;

    function getScrollAmount() {
      var card = carousel.querySelector('.cb-product-card');
      if (!card) return 300;
      var style = window.getComputedStyle(carousel);
      var gap = parseInt(style.columnGap || style.gap || 16, 10);
      return card.getBoundingClientRect().width + gap;
    }

    function updateArrows() {
      var maxScroll = carousel.scrollWidth - carousel.clientWidth - 2;
      prevBtn.disabled = carousel.scrollLeft <= 0;
      nextBtn.disabled = carousel.scrollLeft >= maxScroll;
    }

    prevBtn.addEventListener('click', function () {
      carousel.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
      carousel.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
    });

    carousel.addEventListener('scroll', updateArrows);
    window.addEventListener('resize', updateArrows);
    updateArrows();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moza-cockpit-builder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var ORDER = ['kit', 'base', 'wheel', 'pedal', 'shifter', 'extra'];
    var BUNDLED = ['base', 'wheel', 'pedal']; // grupos que o kit já inclui

    function init(root) {
      if (!root || root.getAttribute('data-mc-ready')) return;
      root.setAttribute('data-mc-ready', '1');

      var data = JSON.parse(root.querySelector('[data-mc-data]').textContent);
      var items = {};
      data.items.forEach(function (i) { items[i.key] = i; });

      var sel = { kit: null, base: null, wheel: null, pedal: null, shifter: null, extra: null };

      var layers = root.querySelectorAll('.mc__layer');
      var chips = root.querySelectorAll('.mc__chip[data-key]');
      var list = root.querySelector('[data-list]');
      var empty = root.querySelector('[data-empty]');
      var totalWrap = root.querySelector('[data-total-wrap]');
      var totalEl = root.querySelector('[data-total]');
      var buy = root.querySelector('[data-buy]');
      var clearBtn = root.querySelector('[data-clear]');
      var note = root.querySelector('[data-note]');
      var noteTimer;

      var fmt = new Intl.NumberFormat(root.getAttribute('data-locale') || 'pt-BR', {
        style: 'currency',
        currency: root.getAttribute('data-currency') || 'BRL'
      });
      function money(cents) { return fmt.format(cents / 100); }

      function showNote(msg, group) {
        note.textContent = msg;
        clearTimeout(noteTimer);
        noteTimer = setTimeout(function () { note.textContent = ''; }, 3500);
        if (group) {
          var wrap = root.querySelector('[data-group-wrap="' + group + '"]');
          if (wrap) {
            wrap.classList.remove('is-shake');
            void wrap.offsetWidth;
            wrap.classList.add('is-shake');
          }
        }
      }

      function clearGroup(g) {
        sel[g] = null;
        if (g === 'base') { sel.wheel = null; sel.extra = null; } // volante e extras dependem da base
        if (g === 'kit') sel.extra = null; // sem kit e sem base, extras saem
      }

      function isLocked(it) {
        if (it.group === 'kit') return false;
        if (sel.kit && BUNDLED.indexOf(it.group) > -1) return 'kit';
        if (it.group === 'wheel' && !sel.base) return 'base';
        if (it.group === 'extra' && !sel.base && !sel.kit) return 'extra';
        return false;
      }

      function toggleItem(it) {
        if (it.group === 'kit') {
          if (sel.kit === it.key) {
            clearGroup('kit');
          } else {
            sel.kit = it.key;
            sel.base = null; sel.wheel = null; sel.pedal = null; // o kit substitui os avulsos
          }
          render();
          return;
        }
        var lock = isLocked(it);
        if (lock === 'kit') {
          showNote(root.getAttribute('data-txt-kit'), 'kit');
          return;
        }
        if (lock === 'base') {
          showNote(root.getAttribute('data-txt-lock'), 'base');
          return;
        }
        if (lock === 'extra') {
          showNote(root.getAttribute('data-txt-extra'), 'base');
          return;
        }
        if (sel[it.group] === it.key) clearGroup(it.group);
        else sel[it.group] = it.key;
        render();
      }

      function selectedItems() {
        return ORDER.map(function (g) { return sel[g] ? items[sel[g]] : null; }).filter(Boolean);
      }

      function render() {
        // camadas (PNGs) no cockpit
        layers.forEach(function (el) {
          var key = el.getAttribute('data-key');
          var on = el.hasAttribute('data-kit')
            ? sel.kit === key
            : sel[el.getAttribute('data-group')] === key;
          el.classList.toggle('is-on', on);
        });

        // bolinhas
        chips.forEach(function (el) {
          var it = items[el.getAttribute('data-key')];
          if (!it) return;
          el.setAttribute('aria-pressed', sel[it.group] === it.key ? 'true' : 'false');
          el.classList.toggle('is-locked', !!isLocked(it));
        });

        // resumo
        var chosen = selectedItems();
        list.innerHTML = '';
        var total = 0;
        var purchasable = 0;
        chosen.forEach(function (it) {
          var li = document.createElement('li');
          li.className = 'mc__row';

          // um item pode ter 1 ou 2 produtos (parts)
          var parts = (it.parts && it.parts.length)
            ? it.parts
            : [{ title: it.title, price: 0, variant: 0, url: '', available: false }];
          var multi = parts.length > 1;

          parts.forEach(function (pt) {
            var name = document.createElement('span');
            name.className = 'mc__row-name';
            name.textContent = multi ? pt.title : it.title;

            var price = document.createElement('span');
            price.className = 'mc__row-price';
            if (!pt.variant) {
              price.textContent = '';
            } else if (pt.available) {
              price.textContent = money(pt.price);
              total += pt.price;
              purchasable++;
            } else {
              price.className = 'mc__soldout';
              price.textContent = 'Esgotado';
            }
            li.appendChild(name);
            li.appendChild(price);
          });

          var actions = document.createElement('div');
          actions.className = 'mc__row-actions';
          parts.forEach(function (pt, idx) {
            if (!pt.url) return;
            var a = document.createElement('a');
            a.href = pt.url;
            a.textContent = multi ? 'Ver produto ' + (idx + 1) : 'Ver produto';
            actions.appendChild(a);
          });
          var rm = document.createElement('button');
          rm.type = 'button';
          rm.textContent = 'Remover';
          rm.addEventListener('click', function () { clearGroup(it.group); render(); });
          actions.appendChild(rm);
          li.appendChild(actions);
          list.appendChild(li);
        });

        var has = chosen.length > 0;
        empty.hidden = has;
        totalWrap.hidden = !has;
        clearBtn.hidden = !has;
        totalEl.textContent = money(total);
        buy.disabled = purchasable === 0;
      }

      chips.forEach(function (el) {
        el.addEventListener('click', function () {
          var it = items[el.getAttribute('data-key')];
          if (it) toggleItem(it);
        });
      });

      clearBtn.addEventListener('click', function () {
        ORDER.forEach(function (g) { sel[g] = null; });
        render();
      });

      buy.addEventListener('click', function () {
        var lines = [];
        selectedItems().forEach(function (it) {
          (it.parts || []).forEach(function (pt) {
            if (pt.available && pt.variant) lines.push({ id: pt.variant, quantity: 1 });
          });
        });
        if (!lines.length) return;
        buy.disabled = true;
        buy.textContent = root.getAttribute('data-txt-adding');
        fetch(root.getAttribute('data-cart-add'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: lines })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('cart');
            window.location.href = root.getAttribute('data-cart-url');
          })
          .catch(function () {
            buy.textContent = root.getAttribute('data-txt-button');
            buy.disabled = false;
            showNote('Não foi possível adicionar ao carrinho. Tente novamente.');
          });
      });

      render();
    }

    function initAll() {
      document.querySelectorAll('[data-mc]').forEach(init);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
